module.exports = __webpack_public_path__ + "static/media/klima-09.ea50d290.jpg";